module.exports = __webpack_public_path__ + "img/unlocked.ba9c3e52.svg";